import React from 'react';
import {teamRoleColor} from '../../utils/teamRoleDisplay';
import './TeamStatsLineupTable.css';

export default function TeamStatsLineupTable({players=[],members=[],roles={},hideCaption=false}) {
  return <table className="TeamStatsLineupTable" aria-label={hideCaption ? "Players & Agents" : undefined}>
    {!hideCaption&&<caption>Players &amp; Agents</caption>}
    <thead><tr><th scope="col">Player</th><th scope="col">Agent</th></tr></thead>
    <tbody>{players.length ? players.map((player,index)=>{
      const member=members.find(person=>(player.uid && person.uid===player.uid) || (player.username && person.username?.toLowerCase()===player.username.toLowerCase()));
      const role=member?.role || roles[player.uid] || 'Player';
      return <tr key={player.uid || player.username || index}><td><span title={role} style={{color:teamRoleColor(role)}}>{member?.username || player.username || 'Player not assigned'}</span></td><td>{player.agent || 'Agent not selected'}</td></tr>;
    }) : <tr><td colSpan={2}>No lineup assigned</td></tr>}</tbody>
  </table>;
}
